import React from 'react';
import { Section } from './Section';
import { Droplets } from 'lucide-react';
export function MechanismSection() {
  return <Section className="bg-forest text-cream" data-id="element-115">
      <div className="text-center mb-10" data-id="element-116">
        <Droplets className="w-12 h-12 text-gold mx-auto mb-4" data-id="element-117" />
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-118">
          Por eso creamos el Protocolo Anti-Inflamación 72H
        </h2>
      </div>
      <div className="bg-forest-light rounded-2xl p-8 md:p-10 border border-forest" data-id="element-119">
        <p className="text-lg leading-relaxed text-cream-dark" data-id="element-120">
          Esta guía digital te acompaña durante 3 días con un paso a paso claro
          para ayudarte a sentir menos hinchazón, menos pesadez y más control
          sobre lo que haces con tu cuerpo.
          <br data-id="element-121" />
          <br data-id="element-122" />
          No se trata de pasar hambre. Se trata de seguir una estructura simple
          que puedas aplicar desde hoy.
        </p>
      </div>
    </Section>;
}